import { configureStore } from '@reduxjs/toolkit';
import { apiService } from './services/ServiceApi';
import Reportreducer from '../store/ReportTypeSlice';
import ListofValuesSlice from './slices/ListofValuesSlice';
import destinationSystemSlice from './slices/destinationSystemSlice';
import errormessageSlice from './slices/errormessageSlice';


const blockSubrequestMiddleware =
  (store: any) => (next: any) => (action: any) => {
    if (
      action.meta?.arg?.headers &&
      action.meta.arg.headers['x-middleware-subrequest']
    ) {
      console.warn(
        'Blocked request with x-middleware-subrequest header:',
        action
      );
      return; // Block the action
    }
    return next(action);
  };

export const appStore = configureStore({
  reducer: {
    [apiService.reducerPath]: apiService.reducer,
    reportTypeVal: Reportreducer,
    listOfValues: ListofValuesSlice,
    destinationSystem: destinationSystemSlice,
    errorMessages: errormessageSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiService.middleware),
});
export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;
